import useUserData from 'hooks/useUserData';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AccessManagement = () => {
  const navigate = useNavigate();
  const { getUser } = useUserData();
  const [isAdmin, setIsAdmin] = useState('');

  const onChangeAdmin = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsAdmin(e.target.value);
  }

  return (
    <div>
      
      <div className="card">
        <div className="card-body">
          <h1 className="h3">Endringstilgang</h1>
            <table className="table cc-table-2-col">
              <tbody>
                <tr>
                  <th>{getUser?.name}</th>
                  <td><div className="form-check">
                      <input className="form-check-input" onChange={onChangeAdmin} type="radio" name="admin" value={getUser?.name} id="admin1" checked={isAdmin === getUser?.name} />
                      <label className="form-check-label" htmlFor="admin1"> Administrator </label>
                    </div></td>
                  <td><span className="text-muted">Slett</span></td>
                </tr>
                </tbody></table>
                <p className="text-muted">Kun administrator kan invitere eller slette brukere.</p>
                <p className="mt-4 mb-0"><a href="#kommerNoeHer" className="btn btn-light border"><i className="bi bi-plus-lg"></i> Inviter bruker</a></p>
                <p className="mt-4 mb-0">
                  <button className="btn btn-primary text-white me-1" onClick={() => navigate(-1)}>Lagre endringer</button>
                  <button className="btn btn-outline-primary" onClick={() => navigate(-1)}>Tilbake</button>
                </p>
        </div>
      </div>

      <p></p></div>
  )
}

export default AccessManagement